@if (usageRate()) {
<h1 class="text-2xl">
  <strong>Grille de vente</strong> - <small>{{ usageRate()?.name }}</small>
  <button matIconButton matTooltip="Modifier cette grille de vente" (click)="updateUsageRate()"><mat-icon>edit</mat-icon></button>
  <button matIconButton matTooltip="Supprimer cette grille de vente" (click)="deleteUsageRate()"><mat-icon>delete</mat-icon></button>
</h1>

<p>
  <strong>Type</strong>: {{ usageRate()?.is_landline ? 'Fixe' : 'Mobile' }}<br>

  @if (usageRate()?.is_exception == false) {
  <strong>Grille par défaut</strong>: {{ usageRate()?.is_default ? 'Oui' : 'Non' }}<br>
  }

  <strong>Grille d'exception</strong>: {{ usageRate()?.is_exception ? 'Oui' : 'Non' }}<br>

  @if (usageRate()?.is_exception == true) {
  <strong>Type d'exception</strong>: {{ getExceptionTypeLabel() }}<br>
  }

  <strong>Description</strong>:<br>
  <span style="white-space: pre-line;">{{ usageRate()?.description }}</span>
</p>

<mat-accordion class="m-4">
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>Tarifs par pays</mat-panel-title>
    </mat-expansion-panel-header>

    <p>
      <button matButton (click)="createUsageRateArea()"><mat-icon>add</mat-icon> Ajouter une entrée</button>
    </p>

    <br>


    <ag-grid-angular
        style="width: 100%; height: 400px;"
        [rowData]="usageRate()?.areas"
        [columnDefs]="areaColumns"
        [autoSizeStrategy]="autoSizeStrategy"
        [localeText]="localeText"
        [getRowId]="getRowId"
        [readOnlyEdit]="true"
        (cellEditRequest)="onAreaCellEditRequest($event)"
        (gridReady)="onAreaGridReady($event)"
    />
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>Tarifs par zone</mat-panel-title>
    </mat-expansion-panel-header>
    
    <p>
      <button matButton (click)="createUsageRateZone()"><mat-icon>add</mat-icon> Ajouter une entrée</button>
    </p>

    <br>

    <ag-grid-angular
        style="width: 100%; height: 400px"
        [rowData]="usageRate()?.zones"
        [columnDefs]="zoneColumns"
        [autoSizeStrategy]="autoSizeStrategy"
        [localeText]="localeText"
        [getRowId]="getRowId"
        [readOnlyEdit]="true"
        (cellEditRequest)="onZoneCellEditRequest($event)"
        (gridReady)="onZoneGridReady($event)"
    />
  </mat-expansion-panel>
</mat-accordion>
}